import React from 'react';
import CompanyProfileWidgetRenderer from './CompanyProfileWidgetRenderer';

const Preview: React.FC = () => (
  <CompanyProfileWidgetRenderer config={{}} />
);

export default Preview;
